// Bootstrap 5 has no `min-w-0` utility, but a flex item defaults to `min-width: auto` (styling
// guide §1 "text-break in a flex row"). This is the row's content column — the flex sibling of
// the fixed-size Avatar in the HorizontalStack chat-message row — so without this floor
// it refuses to shrink below its rendered HTML's unbroken-token width, stretching the whole
// thread (inbox) or `.card` (a record-page conversation card) to match.
.flexFill {
  min-width: 0;
}
